import {Component, ViewEncapsulation} from '@angular/core';
import {MetabaseDashboardComponent} from "./metabase-dashboard.component";

@Component({
  selector: 'app-metabase-dashboard-wrapper',
  standalone: true,
  imports: [MetabaseDashboardComponent],
  templateUrl: './metabase-dashboard-wrapper.component.html',
  styleUrl: './metabase-dashboard-wrapper.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class MetabaseDashboardWrapperComponent {
}
